// Tema lúdico (infantil), controlado pelo tenant REACT_APP_NAME (build-time, global, por deploy).
// 'infantil' ativa o layout lúdico em TODA a interface (home + gate da trilha);
// qualquer outro tenant mantém o layout original. Fonte única de verdade para gatear ajustes de UI.
export const isPlayfulTheme = () => process.env.REACT_APP_NAME === 'infantil';
